// extracted by mini-css-extract-plugin
export default {"enterpriseBox":"enterprise_enterpriseBox__tS+y5"};